import Theme from './Theme.js';
import options from './presets/defaults.js';

var standardTheme = new Theme(options);

export { standardTheme as default };
